const tags = {
  "notifications.tags.role.title": "Elige tu rol",
  "notifications.tags.role.body": "Personalizaremos tu experiencia.",
};

const subscription = {
  "notifications.subscription.info.message":
    "Si has comprado una suscripción recientemente, por favor intenta actualizar tu suscripción haciendo clic en el botón de abajo.",
  "notifications.subscription.refresh.message": "Verificando su suscripción y actualizando el acceso a Be Your Best",
};

const demo = {
  "notifications.demo.expired.title": "Acceso de Prueba Expirado",
  "notifications.demo.expired.message":
    "El acceso de tu cuenta de prueba ha expirado y ya no tienes acceso a las funciones de entrenamiento de Be Your Best.",
  "notifications.demo.expired.info.portal":
    "Para continuar usando Be Your Best, por favor compra un plan de suscripción o inicia sesión con una cuenta diferente.",
  "notifications.demo.expired.info.unity":
    "Para continuar usando Be Your Best, por favor ve a www.portal.beyourbest.com para comprar un plan de suscripción o inicia sesión con una cuenta diferente.",
  "notifications.demo.expired.info.promo": "Usa {{code}} para obtener {{discount}} este {{event}}.",
  "notifications.demo.expired.info.promo-code": "BF25",
  "notifications.demo.expired.info.promo-discount": "40% de descuento en suscripciones anuales",
  "notifications.demo.expired.info.promo-event": "Black Friday",
  "notifications.demo.conversion.failed.title": "Error al activar la prueba",
  "notifications.demo.conversion.failed.message": "Por favor, intenta nuevamente ingresando con la cuenta proporcionada en el correo electrónico.",
};

export const notifications = {
  ...tags,
  ...subscription,
  ...demo,
};
